<template>
  <div class="medical-visit-detail">
		<van-cell-group>
      <van-cell  :border="false">
          <template #title><div class="grey_label">省份城市:</div></template>   
          <div class="info_text">{{item.province}}{{item.city}}</div>
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">医院名称:</div></template>      
          <div class="info_text">{{item.hospital_name}}</div> 
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">医生姓名:</div></template>      
          <div class="info_text">{{item.doctor_name}}</div> 
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">拜访日期:</div></template>      
          <div class="info_text">{{item.vist_date}}</div> 
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">拜访方式:</div></template>      
          <div class="info_text">{{item.vist_mode}}</div> 
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">拜访目标:</div></template>      
          <div class="info_text">{{item.vist_task}}</div> 
      </van-cell>
      <van-cell  :border="false">
          <template #title><div class="grey_label">拜访结果:</div></template>      
          <div class="info_text">{{item.vist_result}}</div> 
      </van-cell>
		</van-cell-group>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';
  import { 
  getDoctorVist
  } from '@/api/publicWelfareStaff' 
  Vue.use(Toast);
export default {
	data(){
		return {
      item:{},//全部数据
      doctor_vist_id:'',
		}
	},
  computed: {
        // ...mapState(['publicWelfareStaff']),
  },
	async created() {
    // this.item=this.publicWelfareStaff.doctor_visit_item
    if(this.$route.query.doctor_vist_id) this.doctor_vist_id=this.$route.query.doctor_vist_id
    await this.init()
    console.log("医护拜访详情",this.item)
	},
	methods:{
    async init(){
      await getDoctorVist({doctor_vist_id:this.doctor_vist_id}).then(res => {
        console.log(res.data)
        if(res.data){
          this.item=res.data
        }
      })
    }
	}
};
</script>

<style lang="scss" scoped>
.medical-visit-detail {
	font-size: 16px;
  min-height: 100vh;
  background-color: #f9f9f9;
  padding: 15px;
  .van-cell-group {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    ::v-deep .grey_label{
        color:#9D9D9D;
        white-space:nowrap;
    }
    .van-cell__title{
      flex: none;
    }
    .van-cell__value{
      flex: 1;
      word-break: break-all;
      margin-left: 15px;
      color: #0A0A0A;
    }
    .info_text{
      text-align: left;
    }
    .result_text{
      word-break: break-all;
    }
  }
}
</style>